export default __webpack_public_path__ + "static/media/p1.e060439f.svg";